import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import Resize_vue_vue_type_script_setup_true_lang_default from "./Resize.vue.script.js";
/* empty css                     */
/* empty css                       */
//#region src/v2/components/resize/Resize.vue
var Resize_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Resize_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-e2c54c18"]]);
//#endregion
export { Resize_default as default };

//# sourceMappingURL=Resize.vue.js.map